<template>
  <section class="strapi" :id="this.sectionId">
    <q-inner-loading :showing="visible" class="fullscreen">
      <q-spinner size="50px" color="secondary" />
    </q-inner-loading>
    <div class="strapi__content" v-if="!this.error">
      <h2 class="title">{{ this.title }}</h2>
      <div class="content" v-html="this.content" />
    </div>
    <div class="strapi__error" v-if="this.error">
      <q-icon name="warning" class="text-negative q-mb-sm" size="md" />
      <p>Content could not be loaded, please contact your administrator.</p>
    </div>
  </section>
</template>

<script>
import showdown from "showdown";

import { formatId } from "@/utils/formatText";

export default {
  name: "StrapiContent",
  props: {
    strapiUrl: String,
  },
  data() {
    return {
      title: "",
      content: "",
      sectionId: "",
      visible: false,
      error: false,
    };
  },
  methods: {
    async fetchContent() {
      this.visible = true;
      // Link is the id we want to target from Strapi to generate our response
      const payload = {
        link: this.strapiUrl,
      };

      await this.$store
        .dispatch("fetchContentItems", payload)
        .then((response) => {
          this.visible = true;
          if (response !== undefined) {
            let item = response.data.data.attributes;
            this.title = item.title;
            this.sectionId = formatId(item.title);
            //  Convert content using showndown library to turn Markdown to HTML
            const converter = new showdown.Converter({ tables: true }),
              markdown = item.content;
            let formattedContent = converter.makeHtml(markdown);
            // Push converted content
            this.content = formattedContent;
            this.visible = false;
          }
        })
        .catch((error) => {
          this.visible = false;
          this.error = true;
          this.errors.push(error);
        });
    },
  },
  mounted() {
    this.fetchContent();
  },
};
</script>

<style lang="scss">
.strapi {
  position: relative;
  &__content {
    min-height: 300px;
    position: relative;
    background: white;
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
    .title {
      display: flex;
      align-items: center;
      padding: 15px 40px;
      border-bottom: 1px solid #eaeaea;
      margin: 0;
    }
    h2 {
      font-weight: 600;
      font-size: 22px;
      line-height: 22px;
    }
    h3 {
      font-weight: 600;
      font-size: 18px;
      line-height: 18px;
      margin-top: 2em;
    }
    h4 {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      margin-top: 2em;
    }
    h5 {
      font-weight: 600;
      line-height: 1.5;
      font-size: 14px;
    }
    h6 {
      font-weight: 600;
      line-height: 1.5;
      font-size: 14px;
    }
    .content {
      padding: 10px 40px 30px;
      ol {
        padding-inline-start: 20px;

        li {
          font-weight: bold;
          line-height: 2;

          ol {
            list-style-type: decimal-leading-zero;

            li {
              font-size: 90%;
              font-weight: normal;
            }
          }
        }
      }

      h3 {
        margin: 0.5rem unset;
        background-color: #f5f6f8;
        padding: 0.5rem;
      }

      h4 {
        margin: unset;
        margin-bottom: 0.5rem;
        margin-left: 0.75rem;
      }

      p + h4 {
        margin-top: 2rem;
      }

      p {
        margin: unset;
        margin-bottom: 0.5rem;
        margin-left: 0.75rem;
      }

      table {
        margin-left: 1rem;
        width: 98%;
        border-spacing: 0;
        thead {
          tr {
            th {
              border-top: 1px solid #ececec;
              border-bottom: 1px solid #ececec;
              padding: 8px 4px;
            }
          }
        }
        tbody {
          tr {
            &:nth-child(even) {
              background: rgba(69, 142, 221, 0.05);
            }
            td {
              font-size: 12px;
              height: 25px;
              font-style: normal;
              padding: 8px 4px;
              border-color: #ececec;
              &:nth-child(odd) {
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
  &__error {
    min-height: 300px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px 40px 30px;

    background: white;
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
  }
}

// Dark Mode
.body {
  &--dark {
    .strapi {
      position: relative;
      &__content {
        background: #353535;
        box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
        .title {
          border-bottom: 1px solid #808080;
        }
        .content {
          table {
            thead {
              tr {
                th {
                  border-top: 1px solid #808080;
                  border-bottom: 1px solid #808080;
                }
              }
            }
            tbody {
              tr {
                &:nth-child(even) {
                  background: #4b4b4b;
                }
                td {
                  border-color: #808080;
                }
              }
            }
          }
        }
      }
      &__error {
        background: #353535;
        box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
      }
    }
  }
}
</style>
